import { ChangeEvent, KeyboardEventHandler, useEffect, useState } from 'react';

import { Input } from '@/components/ui/input';

interface EditableImageNameFieldProps {
  value: string;
  disabled?: boolean;
  onChange: (val: string) => Promise<void> | void;
}

export const EditableImageNameField = ({
  value,
  disabled,
  onChange,
}: EditableImageNameFieldProps) => {
  const [isEditing, setIsEditing] = useState(false);
  const [tempName, setTempName] = useState(value);

  const handleDoubleClick = () => {
    if (!disabled) {
      setIsEditing(true);
    }
  };

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    setTempName(e.target.value);
  };

  const handleBlur = async () => {
    await onChange(tempName);
    setIsEditing(false);
  };

  const handleKeyPress = (e: KeyboardEvent) => {
    if (e.key === 'Enter') {
      handleBlur();
    }
  };

  useEffect(() => {
    setTempName(value);
  }, [value]);

  if (isEditing) {
    return (
      <div className="w-screen max-w-[50vw]">
        <Input
          type="text"
          value={tempName}
          onChange={handleInputChange}
          onBlur={handleBlur}
          onKeyPress={handleKeyPress as unknown as KeyboardEventHandler<HTMLInputElement>}
          className="min-w-80 max-w-full text-base font-semibold text-text-primary"
          autoFocus
        />
      </div>
    );
  }

  return (
    <div className="w-screen max-w-[50vw]">
      <span
        className="block max-w-[50vw] overflow-hidden truncate whitespace-nowrap text-center text-base font-semibold text-text-primary"
        onDoubleClick={handleDoubleClick}
      >
        {value ?? '---'}
      </span>
    </div>
  );
};
